// extracted by mini-css-extract-plugin
export default {"top-menu--container":"top-menu_top-menu--container__ytfs0","login-register-btns":"top-menu_login-register-btns__I1v4b"};